export function normalizePakistanPhone(value: string): string | null {
  let digits = value.replace(/\D/g, '');
  if (digits.startsWith('0092')) digits = digits.slice(2);
  if (digits.startsWith('0')) digits = `92${digits.slice(1)}`;
  if (digits.length === 10 && digits.startsWith('3')) digits = `92${digits}`;
  return /^923\d{9}$/.test(digits) ? `+${digits}` : null;
}

export function displayPakistanPhone(value: string): string {
  const normalized = normalizePakistanPhone(value);
  if (!normalized) return value;
  const digits = normalized.slice(1);
  return `+92 ${digits.slice(2, 5)} ${digits.slice(5)}`;
}

export function customerSearchValue(customer: { name?: string; phone?: string; phoneNormalized?: string; address?: string }): string {
  return `${customer.name || ''} ${customer.phone || ''} ${customer.phoneNormalized || ''} ${customer.address || ''}`.toLowerCase();
}
